<template>
  <div class="yxtbiz-ote-type-selector-dropdown" :class="{
    'yxtbiz-ote-type-selector-dropdown--large': large
  }">
    <yxt-dropdown trigger="click" @visible-change="change" custom-elm>
      <div
        ref="refBtn"
        class="yxtbiz-ote-type-selector-dropdown__btn"
        :class="{ 'yxtbiz-ote-type-selector-dropdown__btn--active': showMenu }"
      >
        <span class="ellipsis"
          >{{ showTitle ? title + ' ' : '' }}{{ name }}</span
        >
        <yxt-svg
          class="ml4"
          :class="showMenu ? 'trans-270deg' : 'trans-90deg'"
          width="14px"
          height="14px"
          icon-class="right"
        />
      </div>
      <yxt-dropdown-menu
        slot="dropdown"
        class="yxtbiz-ote-type-selector-dropdown__dropdown"
      >
        <div class="p12" slot="custom" @mousedown.stop="">
          <div class="yxtbiz-ote-type-selector-dropdown__title">{{ title }}</div>
          <div class="yxtbiz-ote-type-selector-dropdown__menus" :class="{
              'yxtbiz-ote-type-selector-dropdown__menus--long': long
            }">
            <div
              :style="{
                minWidth: itemMinWidth
              }"
              class="yxtbiz-ote-type-selector-dropdown__menu"
              :class="{
                'yxtbiz-ote-type-selector-dropdown__menu--selected': menu.id === value,
                'yxtbiz-ote-type-selector-dropdown__menu--center': itemCenter
              }"
              :key="menu.id"
              v-for="menu in menus"
              @click="select(menu)"
            >
              <yxt-svg
                :remote-url="SvgMediaUrl"
                v-if="menu.icon"
                width="16px"
                height="16px"
                class="mr8"
                :icon-class="menu.icon"
              ></yxt-svg>
              {{ menu.name }}
            </div>
          </div>
        </div>
      </yxt-dropdown-menu>
    </yxt-dropdown>
  </div>
</template>

<script>
import { SvgMediaUrl } from '../const';
export default {
  name: 'YxtbizOteTypeSelectorDropdown',
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    //  选项列表 [{id,name,icon}]
    menus: {
      type: Array,
      default: () => []
    },
    value: {
      type: String | Number,
      default: ''
    },
    // 每个选项的最小宽度
    itemMinWidth: {
      type: String,
      default: '38px'
    },
    // 每个选项的内容是否居中对齐，默认左对齐
    itemCenter: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    long: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      SvgMediaUrl,
      showMenu: false,
      name: ''
    };
  },
  created() {},
  watch: {
    value: {
      immediate: true,
      handler(val) {
        const menu = this.menus.find(t => t.id === val);
        this.name = (menu && menu.name) || '';
      }
    }
  },
  methods: {
    change(s) {
      this.showMenu = s;
    },
    select(menu) {
      this.$emit('input', menu.id);

      this.$refs.refBtn.click();
    }
  }
};
</script>
